import { useMutation } from '@tanstack/react-query';
import { CreateInternalScheduleReq, CreateInternalScheduleResp } from './createSchedule';
import { queryFetch } from '@services/api';
import { useJobRefetch } from '@hooks/job/refetch';

export const useUpdateInternalSchedule = ({
  id,
  callback,
}: {
  id: string;
  callback: (data: CreateInternalScheduleResp) => void;
}) => {
  const { refetch } = useJobRefetch({ schedule: { type: 'internal', action: 'update' } });

  const { mutate, isPending } = useMutation({
    mutationFn: (data: CreateInternalScheduleReq): Promise<CreateInternalScheduleResp> => {
      const { scheduleId } = data;
      return queryFetch({
        url: `jobs/${id}/internal_schedules/${scheduleId}/reschedule`,
        data,
        opt: { method: 'POST' },
      });
    },
    onError: (err) => {
      console.error(err);
    },
    onSuccess: async ({ success }) => {
      if (!success) return;
      await refetch();
    },
    onSettled: (data) => {
      if (data) callback(data);
    },
  });

  return {
    reschedule: mutate,
    isUpdating: isPending,
  };
};
